var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortAppliedChange = function SvgSortAppliedChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "sort-arrow"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3020_17338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3020_17338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "down",
    d: "M14.659 19.5125C14.559 19.5125 14.4653 19.4951 14.3778 19.4604C14.2903 19.4256 14.2118 19.3736 14.1424 19.3041L11.184 16.3458C11.0313 16.1943 10.9584 16.0175 10.9653 15.8156C10.9722 15.6135 11.0521 15.4327 11.2049 15.2733C11.3577 15.1272 11.5347 15.0541 11.7361 15.0541C11.9375 15.0541 12.1146 15.1305 12.2674 15.2833L13.9132 16.95V11.575C13.9132 11.3625 13.9847 11.1843 14.1276 11.0406C14.2705 10.8968 14.4476 10.825 14.6588 10.825C14.8701 10.825 15.0486 10.8968 15.1945 11.0406C15.3403 11.1843 15.4132 11.3625 15.4132 11.575V16.95L17.0799 15.2833C17.2327 15.1305 17.4109 15.0541 17.6147 15.0541C17.8183 15.0541 17.9942 15.1305 18.1424 15.2833C18.2952 15.4315 18.3715 15.6074 18.3715 15.811C18.3715 16.0147 18.2952 16.193 18.1424 16.3458L15.184 19.3041C15.109 19.3736 15.0278 19.4256 14.9403 19.4604C14.8528 19.4951 14.759 19.5125 14.659 19.5125Z",
    fill: "#33445E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "up",
    d: "M9.13411 12.6093C9.27995 12.7531 9.45849 12.825 9.66974 12.825C9.88099 12.825 10.0581 12.7531 10.201 12.6093C10.3439 12.4656 10.4154 12.2875 10.4154 12.075V6.69995L12.082 8.34578C12.2348 8.49856 12.4119 8.57495 12.6133 8.57495C12.8147 8.57495 12.9918 8.5019 13.1445 8.35578C13.2973 8.19634 13.3737 8.0194 13.3737 7.82495C13.3737 7.63051 13.2973 7.4569 13.1445 7.30412L10.1862 4.34578C10.1168 4.27634 10.0383 4.22426 9.95078 4.18953C9.86328 4.15481 9.76953 4.13745 9.66953 4.13745C9.56953 4.13745 9.47578 4.15481 9.38828 4.18953C9.30078 4.22426 9.21953 4.27634 9.14453 4.34578L6.1862 7.30412C6.03342 7.4569 5.95703 7.63516 5.95703 7.83891C5.95703 8.04252 6.03342 8.21842 6.1862 8.36662C6.33439 8.5194 6.5103 8.59578 6.71391 8.59578C6.91766 8.59578 7.09592 8.5194 7.2487 8.36662L8.91536 6.69995V12.075C8.91536 12.2875 8.98828 12.4656 9.13411 12.6093Z",
    fill: "#B6C2D6"
  })))));
};
export default SvgSortAppliedChange;